module.exports = __webpack_public_path__ + "static/img/home2.fb20d870.png";